<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on }">
      <v-btn @click="save()" color='success' :loading="processingSave" persistent>
        <v-icon small class="mr-1">
          mdi-content-save
        </v-icon>
        Salvar
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="grey lighten-3">
        <v-icon medium class="mr-2">mdi-file-check</v-icon>
        <span class="title font-weight-regular">Salvar Documento</span>
      </v-card-title>
      <v-card-text>
        <v-layout column class="text-xs-center">
          <v-flex>
            <div xs12>
              <img src="/static/images/settings/file-save-update.png" width="96">
            </div>
            <div xs12>
              <span class="grey--text text--darken-2">Seu modelo de documento foi salvo.</span>
            </div>
            <div xs12>
              <span class="grey--text text--darken-2">Deseja sair do modo de edição?</span>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="justify-space-around">
        <v-btn color="grey darken-2" flat @click="dialog = false">
          Continuar editando
        </v-btn>
        <v-btn color="blue darken-1 white--text" @click="$router.push('/configuracao/documentos/lista')">
          Sair da edição
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>

import DocumentTypeService from "@/services/system/DocumentTypeService";
import { isEmpty, map } from 'lodash'

export default {
  name: 'SaveDocumentTypeDialog',
  props: ['html'],
  data() {
    return {
      dialog: false,
      processingSave: false,
      isEmpty
    };
  },
  computed: {
    documentToEdit() {
      return this.$store.getters.documentToEdit;
    }
  },
  methods: {
    async save() {
      this.processingSave = true;

      if (!this.documentToEdit.name) {
        this.processingSave = false;
        return this.$store.dispatch('toggleSnackbar', {
          show: true,
          color: 'error',
          message: 'Você precisa definir um nome e uma sigla para o modelo documento.',
          messageIcon: 'mdi-alert-outline',
        });
      }

      const payload = {
        id: this.documentToEdit.id,
        name: this.documentToEdit.name,
        abbreviation: this.documentToEdit.abbreviation,
        content_raw: this.reparseHtml(),
        fields: this.documentToEdit.fields.model_fields
      };


      try {
        if (this.documentToEdit.id) {
          await DocumentTypeService.update(payload, this.documentToEdit.id)
        } else {
          await DocumentTypeService.create(payload)
        }

        this.dialog = true;
      } catch (err) {
        this.$store.dispatch('toggleSnackbar', {
          show: true,
          color: 'error',
          message: err.join(', '),
          button: { show: true, text: 'Fechar', message: '' },
          timeout: 6000,
        });
      } finally {
        this.processingSave = false
      }
    },
    reparseHtml() {
      const html = this.html;
      const reparsed = html.replace(
        /<span[^>]*?class="mceNonEditable"[^>]*?>.*?<\/span>/gm,
        (span) => {
          const [paramName] = span.match(/id="(.*?)"/gm) || [];
          return `#{${paramName.replace(/id=|"/gm, '')}}`;
        },
      );
      return reparsed;
    },
  },
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/components/settings/document_types/SaveDocumentTypeDialog.vue